import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessConnection } from "@/shared/types/api/business-mode.types"

export const updateAutoTrainingApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessConnection"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      updateAutoTraining: builder.mutation<BusinessConnection, { automaticTrainingEnabled: boolean }>({
        query: ({ automaticTrainingEnabled }) => ({
          url: `/api/v1/business/connections/auto-training`,
          method: "PATCH",
          body: { automatic_training_enabled: automaticTrainingEnabled }
        }),
        invalidatesTags: () => [{ type: "BusinessConnection" as const }]
      })
    })
  })

export const { useUpdateAutoTrainingMutation } = updateAutoTrainingApi
